export default class CompleteBeneficiaryInfoService {
  static hasToCompleteBeneficiaryInfo({ affBeneficiary }) {
    return !affBeneficiary?.name || !affBeneficiary?.city || !affBeneficiary?.country_code || !affBeneficiary?.postal_code;
  }
}
